import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import { IRouter } from 'i2g-ng-ui';

@Injectable()
export class CommonHeaderLayoutBuilder {
  constructor(
    private _translateService: TranslateService,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {}

  buildLoginRoute(trackingScreenName, trackingObject): IRouter {
    return {
      label: this._translateService.instant('ACTION.LOG_IN'),
      route: ['/'],
      trackingObject: trackingObject,
      trackingAction: this._trackingActionBuilder.buildButtonTapped(
        'sign_in',
        trackingScreenName
      ),
    };
  }
}
